<template>
  <section id="why_us" class="py-10 py-sm-16">
    <v-container>
      <v-row justify="center" class="mb-10 text-center">
        <v-col cols="12">
          <h2
            :class="[
              'font-weight-bold',
              $vuetify.breakpoint.mdAndUp ? 'text-h2' : 'text-h4',
            ]"
          >
            {{ $t("section_3_title") }}
          </h2>
        </v-col>
      </v-row>
      <v-row>
        <whyUsCard
          v-for="(card, i) in whyUs"
          :key="i"
          :image="card.image"
          :points="card.points"
        />
      </v-row>
    </v-container>
  </section>
</template>

<script>
import Vue from "vue";
import whyUsCard from "@/components/cards/card_1.vue";

export default Vue.extend({
  name: "whyUS-section",

  components: {
    whyUsCard,
  },

  computed: {
    whyUs() {
      return [
        {
          image: require("@/assets/image_1.jpg"),
          points: [
            this.$t("section_3_euro_1"),
            this.$t("section_3_euro_2"),
            this.$t("section_3_euro_3"),
            this.$t("section_3_euro_4"),
          ],
        },
        {
          image: require("@/assets/image_2.jpg"),
          points: [
            this.$t("section_3_qrcode_1"),
            this.$t("section_3_qrcode_2"),
            this.$t("section_3_qrcode_3"),
          ],
        },
        {
          image: require("@/assets/image_3.jpg"),
          points: [
            this.$t("section_3_technology_1"),
            this.$t("section_3_technology_2"),
          ],
        },
      ];
    },
  },
});
</script>
